import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../../../shared/components/loader/linearProgress";
import {
  getLocalStorageData,
  setLocalStorageData,
} from "../../../../shared/utils/localStorage";
import { LocalStorageContext } from "../../../../contexts/LocalStorageContext";

const Home = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { updateUserData, updatePropertyId } = useContext(LocalStorageContext);

  useEffect(() => {
    const initialize = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const urlToken = params.get("token");

        if (urlToken) {
          setLocalStorageData("token", urlToken);
        }

        const token = getLocalStorageData("token");

        let response;
        if (token) {
          response = await fetch(
            `${process.env.REACT_APP_API_URL}/customers/get/by-token`,
            {
              headers: token ? { Authorization: `Bearer ${token}` } : undefined,
            }
          );

          if (response?.ok) {
            const data = await response.json();
            const propertyId = data?.data?.samplePropertyID;
            setLocalStorageData("userData", data?.data);
            updateUserData(data?.data);
            updatePropertyId(propertyId);
            navigate(`/dashboard/${propertyId}`);
          } else {
            const redirectUrl = `${process.env.REACT_APP_GLOBAL_AUTH_CLIENT_FRONTEND}/login`;
            window.location.href = redirectUrl;
          }
        } else {
          const redirectUrl = `${process.env.REACT_APP_GLOBAL_AUTH_CLIENT_FRONTEND}/login`;
          window.location.href = redirectUrl;
        }
      } catch (error) {
        const redirectUrl = `${process.env.REACT_APP_GLOBAL_AUTH_CLIENT_FRONTEND}/login`;
        window.location.href = redirectUrl;
      }
    };

    initialize();
  }, []);

  return <Loader />;
};

export default Home;
